"use client";
import style from './sidebarCart.module.scss';
import CartProduct from '../../pages/cart/partials/cart-product/CartProduct';
import { useTranslations } from 'next-intl';
import { formatPrice } from '@/projectRoot/src/utils/handlers/productsHandler';
import LinkUrl from '../general/link/LinkUrl';
import { useCart } from '@/projectRoot/src/contexts/CartContext';
import ZeroState from '../zero-state/ZeroState';
import { useApiClient } from '@/projectRoot/src/contexts/ApiClientContext';
import { useRouter } from 'next/navigation';

interface Props {
    classes?: string[];
}

const SidebarCart = ({classes = []}: Props) => {
    const t = useTranslations();
    const {cart, cartState} = useCart();
    const {apiClient} = useApiClient();
    const router = useRouter();

    const initCheckout = async() => {
      try{
        const response = await apiClient.webshopCheckout().init(cartState);
        if(response.data){
          router.push(response.data.redirect_url.url);
        }
      }catch(err){
        console.log(err);
      }
    }
    // console.log('sidebar: ', cart)
  return (
    cart && cart.items?.length > 0
    ?
    <aside className={`${style.sidebarCart} ${classes.join(' ')}`}>
      <div className={style.productsWrapper}>
        {
            cart.items.map((prod, index) => <CartProduct item={prod} key={prod.product_id + '_' + index} classes={[style.prodItem]} />)
        }
      </div>
      <div className={style.actions}>
        <p className={style.totalPrice}>
            {t('subtotal')} 
            <span>
                {formatPrice(cart.final_price)}
            </span>
        </p>
        <LinkUrl onClick={initCheckout} classes={[style.darkLink, style.link]} text={t('checkout')} noLink />
        <LinkUrl url={`/ws/${t('RoutesTranslations.cart').toLocaleLowerCase()}`} classes={[style.link]} text={t('view_cart')} />
      </div>
    </aside>
    : 
    <ZeroState 
        title={t('your_cart_is_empty')}
        text={t('empty_cart_text')}
        action={{
            text: t('start_shopping'),
            url: `/${t('RoutesTranslations.products').toLocaleLowerCase()}`
        }}
        classes={[style.zeroState]}
    />
  )
};

export default SidebarCart;
